export default __webpack_public_path__ + "static/media/pro_3.3359ba9b.jpg";